export const ConsoleTexts = {
    startText: {
        "EN": "Type 'help' to show all available command.",
        "NL": "Typ 'help' om alle commando's te zien."
    },
    startMissionText: {
        "EN": "Starting mission...",
        "NL": "Missie starten..."
    },
    helpText: {
        "help": {
            "EN": "Show all commands.",
            "NL": "Toon alle commando's."
        },
        "exit": {
            "EN": "Exit this window.",
            "NL": "Sluit dit venster."
        },
        "start": {
            "EN": "Start the mission.",
            "NL": "Start de missie."
        }
    }
};

export const DialogTexts = {
    commandNotFoundText: (command) => {
        return {
            "EN": "Command '" + command + "' is not found.",
            "NL": "Commando '" + command + "' is niet gevonden."
        };
    }
};

export const DoorTexts = {
    enterTokenText: {
        "EN": "ENTER TOKEN: ",
        "NL": "VOER TOKEN IN: "
    },    
    errorText: {
        "EN": "Incorrect token, try again",
        "NL": "Token is incorrect, probeer opnieuw"
    },
    buttonText: {
        "EN": "UNLOCK",
        "NL": "ONTGRENDEL"
    }
};

export const FlagTexts = {
    tokenText: {
        "EN": "Well done! <br/>You found the token! <br/><br/>TOKEN: ",
        "NL": "Goed gedaan! <br/>Je hebt de token gevonden! <br/><br/>TOKEN: "
    }
};

export const LanguagePickerTexts = {
    chooseLanguageText: {
        "EN": "Choose your language",
        "NL": "Kies je taal"
    }
};